export default function ServicesHero() {
  return (
    <section className="relative pt-24 pb-0 min-h-[55vh] flex items-end overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=clean%20modern%20Australian%20shared%20house%20kitchen%20with%20bright%20white%20cabinets%2C%20stainless%20appliances%2C%20natural%20light%2C%20tidy%20and%20well-maintained%20interior%2C%20contemporary%20design%2C%20welcoming%20residential%20kitchen%20photography&width=1920&height=650&seq=services-hero1&orientation=landscape"
          alt="Modern fully furnished home services"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-900/65 to-navy-950/92" />
      </div>
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pb-16">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 h-0.5 bg-gold-400" />
          <span className="text-gold-400 text-sm font-medium tracking-widest uppercase">All-Inclusive Living</span>
        </div>
        <h1 className="font-heading text-5xl lg:text-6xl font-bold text-white leading-tight max-w-3xl">
          Everything You Need,<br />
          <span className="text-gold-400 italic">All Included.</span>
        </h1>
      </div>
    </section>
  );
}
